
// import aboutSectionImage from './../../../assets/Images/homepage/aboutImage.png';
// import { Button, Card } from 'react-bootstrap'

import { useNavigate } from 'react-router-dom';
import shopingCardData from '../../data/shopingCardData.json';

const HomeCardSection = ({ selectedCategory }) => {
    const navigate = useNavigate();
    const cardData = shopingCardData.shopingCard;

    // Filter logic
    const filteredData = selectedCategory === "All"
        ? cardData
        : cardData.filter(item => item.category?.toLowerCase() === selectedCategory?.toLowerCase());

    return (
        <section className="sectionPadding pt-3 pt-lg-5 homepage-slider">
            <div className="container">
                <div className="row g-3 g-md-4 justify-content-center">
                    {filteredData.length > 0 ? (
                        filteredData.map((card) => {
                            return (
                                <div key={card.id} className="col-lg-3 col-md-4 col-6">
                                    <div className='shop_card pointer-event mb-4' onClick={() => navigate(`/product/${card.id}`)} style={{ cursor: 'pointer' }}>
                                        <img className='card_image' src={card.productImage} alt='card' />
                                        <div className='text-center content_layer unvisible_onHover'>
                                            <p className='category_name'>{card.category}</p>
                                            <p className='card_title'>{card.title}</p>
                                            <p className='price'>${card.price}</p>
                                            <div className='size_btn'>
                                                <p>S</p>
                                                <p>M</p>
                                                <p>L</p>
                                                <p>XL</p>
                                                <p>XXL</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    ) : (
                        <div className="col-12 text-center py-5" data-aos="fade-up">
                            <h4 className="text-muted fw-light">No products found in this category.</h4>
                            <p className="small text-muted text-uppercase letter-spacing-2">Check back soon for new arrivals!</p>
                        </div>
                    )}
                </div>
            </div>
        </section>

    );
};

export default HomeCardSection;